export const MODAL_REGISTRY = {
    gosContractSearchSelectorModal: {
        labelKey: 'modals.modalSizeSettings.gosContractSearchSelectorModal',
    },
    contractorSelectorModal: {
        labelKey: 'modals.modalSizeSettings.contractorSelectorModal',
    },
    contractorGroupAllSelectorModal: {
        labelKey: 'modals.modalSizeSettings.contractorGroupAllSelectorModal',
    },
    storeSelectorModal: {
        labelKey: 'modals.modalSizeSettings.storeSelectorModal',
    },
    lotsSelectorModal: {
        labelKey: 'modals.modalSizeSettings.lotsSelectorModal',
    },
    goodsSelectorModal: {
        labelKey: 'modals.modalSizeSettings.goodsSelectorModal',
    },
    pricingModelSelectorModal: {
        labelKey: 'modals.modalSizeSettings.pricingModelSelectorModal',
    },
    invoiceOutItemCreator: {
        labelKey: 'modals.modalSizeSettings.invoiceOutItemCreator',
    },
    kizExchangeGridModal: {
        labelKey: 'modals.modalSizeSettings.kizExchangeGridModal',
    },
    inventoryVedSelectorModal: {
        labelKey: 'modals.modalSizeSettings.inventoryVedSelectorModal',
    },
    cashRegisterSelectorModal: {
        labelKey: 'modals.modalSizeSettings.cashRegisterSelectorModal',
    },
    settingKkmModal: {
        labelKey: 'modals.modalSizeSettings.settingKkmModal',
    },
    constructorDocumentSelectedModal: {
        labelKey: 'modals.modalSizeSettings.constructorDocumentSelectedModal',
    },
    schemeSelectedModal: {
        labelKey: 'modals.modalSizeSettings.schemeSelectedModal',
    },
    cashSessionSelectorModal: {
        labelKey: 'modals.modalSizeSettings.cashSessionSelectorModal',
    },
    goodsGroupAllSelectorModal: {
        labelKey: 'modals.modalSizeSettings.goodsGroupAllSelectorModal',
    },
    goodsGroupByGoodSelectorModal: {
        labelKey: 'modals.modalSizeSettings.goodsGroupByGoodSelectorModal',
    },
    pricingAdpriceScaleTypeSelectorModal: {
        labelKey: 'modals.modalSizeSettings.pricingAdpriceScaleTypeSelectorModal',
    },
    pricingExtremeAdpriceSchemaTypeSelectorModal: {
        labelKey: 'modals.modalSizeSettings.pricingExtremeAdpriceSchemaTypeSelectorModal',
    },
    pricingPriceCalcSchemaTypeSelectorModal: {
        labelKey: 'modals.modalSizeSettings.pricingPriceCalcSchemaTypeSelectorModal',
    },
    pricingRoundSchemaSelectorModal: {
        labelKey: 'modals.modalSizeSettings.pricingRoundSchemaSelectorModal',
    },
    pricingMinAdpriceSchemaTypeSelectorModal: {
        labelKey: 'modals.modalSizeSettings.pricingMinAdpriceSchemaTypeSelectorModal',
    },
    pricingConditionParamSelectorModal: {
        labelKey: 'modals.modalSizeSettings.pricingConditionParamSelectorModal',
    },
    kizInventoryItemSelectorModal: {
        labelKey: 'modals.modalSizeSettings.kizInventoryItemSelectorModal',
    },
    gosContractFundingSourceMultiSelectorModal: {
        labelKey: 'modals.modalSizeSettings.gosContractFundingSourceMultiSelectorModal',
    },
    labelDesignerTemplateMultiSelectorModal: {
        labelKey: 'modals.modalSizeSettings.labelDesignerTemplateMultiSelectorModal',
    },
    sysOptionsEditModal: {
        labelKey: 'modals.modalSizeSettings.sysOptionsEditModal',
    },
} as const;

export type ModalKey = keyof typeof MODAL_REGISTRY;